import React, { useState } from 'react';
import './AdminTagManagement.css';
import SvgIcon from '../../components/SvgIcon';
import AdminTagManagement from './AdminTagManagement';
import AdminLearnerTagManagement from './AdminLearnerTagManagement';

const ProjectTagAllocationHub = ({ onBack, onSwitchView }) => {
  // 'hub' | 'manageTags' | 'manageLearners'
  const [currentSubView, setCurrentSubView] = useState('hub');

  // If user selected "Manage/Create Project Tag"
  if (currentSubView === 'manageTags') {
    return (
      <AdminTagManagement
        onBack={() => setCurrentSubView('hub')}
        onSwitchView={onSwitchView}
        isHubChild={true}
      />
    );
  }

  // If user selected "Manage Learners"
  if (currentSubView === 'manageLearners') {
    return (
      <AdminLearnerTagManagement
        onBack={() => setCurrentSubView('hub')}
        onSwitchView={onSwitchView}
      />
    );
  }

  // Default: Project Tag Allocation Hub Landing Page
  return (
    <div className="tag-management-container" data-testid="project-tag-allocation-hub">
      {/* ── Top Bar ── */}
      <header className="tag-top-bar" data-testid="course-tag-allocation-hub">
        <div className="tag-top-bar-left">
          <div className="tag-breadcrumbs">
            <span 
              className="tag-breadcrumb-link" 
              onClick={() => onSwitchView ? onSwitchView('adminCourses') : onBack && onBack()}
              data-testid="hub-breadcrumb-courses"
            >
              Courses
            </span>
            <span>/</span>
            <span style={{ color: '#0f172a', fontWeight: 600 }}>Project Tag Allocation</span>
          </div>
          <h1 className="tag-page-title">
            <SvgIcon name="tag" size={24} />
            <span>Project Tag Allocation & Cohort Management</span>
          </h1>
          <p className="tag-page-subtitle">
            Manage special project codes, configure cohort course eligibility, or allocate student and learner cohorts.
          </p>
        </div>
        <div className="tag-top-bar-right">
          <button 
            className="btn-secondary" 
            onClick={() => onSwitchView ? onSwitchView('adminCourses') : onBack && onBack()}
            data-testid="hub-back-to-courses-btn"
          >
            <SvgIcon name="arrowLeft" size={16} />
            <span>Back to Courses</span>
          </button>
        </div>
      </header>

      {/* ── Hub Dual-Action Cards Grid ── */}
      <div className="tag-hub-grid" data-testid="tag-hub-grid">
        
        {/* Left Option: Manage/Create Project Tag */}
        <div 
          className="tag-hub-card"
          data-testid="hub-manage-tags-card"
          onClick={() => setCurrentSubView('manageTags')}
        >
          <div className="tag-hub-card-badge indigo">
            <SvgIcon name="tag" size={14} />
            <span>Tag & Course Matrix</span>
          </div>

          <div className="tag-hub-card-icon-wrap indigo">
            <SvgIcon name="tag" size={32} />
          </div>

          <div className="tag-hub-card-content">
            <h2 className="tag-hub-card-title">Manage/Create Project Tag</h2>
            <p className="tag-hub-card-desc">
              Create and configure unique project codes (e.g. CYBER-GOV-2026), set cohort quotas and expiry rules, and drag-and-drop courses from the available course pool.
            </p>

            <ul className="tag-hub-features-list">
              <li>
                <SvgIcon name="checkCircle" size={16} />
                <span>Create & validate unique project codes inline</span>
              </li>
              <li>
                <SvgIcon name="checkCircle" size={16} />
                <span>Active Tag Allocation Inspector & Drop Zone</span>
              </li>
              <li>
                <SvgIcon name="checkCircle" size={16} />
                <span>Course pool search, filters & batch assignment</span>
              </li>
            </ul>
          </div>

          <div className="tag-hub-card-footer">
            <button 
              className="tag-hub-btn indigo"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentSubView('manageTags');
              }}
              data-testid="enter-manage-tags-btn"
            >
              <span>Manage Project Tags & Courses</span>
              <SvgIcon name="chevronRight" size={16} />
            </button>
          </div>
        </div>

        {/* Right Option: Manage Learners */}
        <div 
          className="tag-hub-card"
          data-testid="hub-manage-learners-card"
          onClick={() => setCurrentSubView('manageLearners')}
        >
          <div className="tag-hub-card-badge purple">
            <SvgIcon name="users" size={14} />
            <span>Student & Cohort Allocation</span>
          </div>

          <div className="tag-hub-card-icon-wrap purple">
            <SvgIcon name="users" size={32} />
          </div>

          <div className="tag-hub-card-content">
            <h2 className="tag-hub-card-title">Manage Learners</h2>
            <p className="tag-hub-card-desc">
              Manage student and learner allocations between created project tags. Inspect cohort rosters, monitor capacity quotas, and drag-and-drop learners into tags.
            </p>

            <ul className="tag-hub-features-list">
              <li>
                <SvgIcon name="checkCircle" size={16} />
                <span>Searchable tag inspector with live cohort quota tracking</span>
              </li>
              <li>
                <SvgIcon name="checkCircle" size={16} />
                <span>Drag-and-drop learner cards into the active tag drop zone</span>
              </li>
              <li>
                <SvgIcon name="checkCircle" size={16} />
                <span>Learner pool search by name, email, organisation & sector</span>
              </li>
            </ul>
          </div>

          <div className="tag-hub-card-footer">
            <button 
              className="tag-hub-btn purple"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentSubView('manageLearners');
              }}
              data-testid="enter-manage-learners-btn"
            >
              <span>Manage Learners Allocation</span>
              <SvgIcon name="chevronRight" size={16} />
            </button>
          </div>
        </div>

      </div>

    </div>
  );
};

export default ProjectTagAllocationHub;
export { ProjectTagAllocationHub, ProjectTagAllocationHub as CourseTagAllocationHub };
